module.exports = __webpack_public_path__ + "img/201904.34d6915c.jpg";